import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import LogoService from '../../services/logo.service';
import { Container, Row, Col } from "react-bootstrap";

const AddLogoModal = (props) => {
    const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const [logoLocations, setLogoLocations] = useState(null);
  const [logos, setLogos] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [updateMode, setUpdateMode] = useState('color');


  const modalClose = () => {
    resetForm();
    props.closeModal(false);
  }

  useEffect(() => {
    async function fetchData() {
        var loadedLogos = await LogoService.getLogosForSubsite();
        setLogos(loadedLogos.data);
      
        var newLogoLocations = await LogoService.getLogoLocations();
        setLogoLocations(newLogoLocations.data);
        setSelectedLogo(loadedLogos.data[0]);
        setSelectedLocation(newLogoLocations.data[0].id);

    }
    fetchData();   
  }, []);

  const resetForm = () => {
    setSelectedLogo(logos[0]);
    setSelectedLocation(logoLocations[0].id);
  }

  const handleSubmit = () => {
    props.addLogo(selectedLocation, selectedLogo, updateMode);
    resetForm();

    props.closeModal(false);
  }

    const updateModeChanged = (mode) => {
        setUpdateMode(mode);
    }

  
  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Add Logo<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <Container>
                    <Row>
                      <Col>
                        Selected Logo Set:
                      </Col>
                      <Col>
                      {selectedLogo && selectedLogo.oppoColor && (
                                <div style={{border: "1px solid #000000"}}>
                                  <img alt="Logo" src={apiUrl + selectedLogo?.imageUrl} style={{borderWidth: "1px", margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}}/>
                                  <img alt="Logo" src={apiUrl + selectedLogo?.oppoColor.imageUrl} style={{borderWidth: "1px", margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}}/>
                      </div>
                      )}
                      {selectedLogo && !selectedLogo.oppoColor && (
                                <div style={{border: "1px solid #000000"}}>
                                  <img alt="Logo" src={apiUrl + selectedLogo?.imageUrl} style={{borderWidth: "1px", margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}}/>
                                  </div>
                      )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Update Mode:
                        </Col>
                        <Col>
                        <input type="radio" id="color" name="updateMode" onClick={() => updateModeChanged('color')} checked={updateMode === "color" ? true : false} /> Update this color<br/>
                        <input type="radio" id="all"  name="updateMode" onClick={() => updateModeChanged('all')} checked={updateMode === "all" ? true : false}/> Update All Colors
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Location:
                      </Col>
                      <Col>
                      <select name="location" value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)}>
                            {logoLocations && logoLocations.map((location) => (
                                <option value={location.id}>{location.description}</option>
                            ))
                            }
                        </select>
                      </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button onClick={handleSubmit}>Add Logo Set</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        {logos && logos.map((logo) => {
                            if(logo.oppoColor) {
                                return (<div style={{border: "1px solid #000000"}}>
                                    <img alt="Logo" src={apiUrl + logo.imageUrl} style={{margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}} onClick={() => setSelectedLogo(logo)} />
                                    <img alt="Logo" src={apiUrl + logo.oppoColor.imageUrl} style={{margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}} onClick={() => setSelectedLogo(logo)} />
                                    {logo.decoType}
                                    </div>
                                );
                            } else {
                                return (
                                    <div style={{border: "1px solid #000000"}}>
                                    <img alt="Logo" src={apiUrl + logo.imageUrl} style={{margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}} onClick={() => setSelectedLogo(logo)} />
                                    {logo.decoType}
                                    </div>
                                    );
                            }
                        })}
                        
                        </Col>
                    </Row>
                </Container>
    </Modal.Body>
    </Modal>
  );
};

export default AddLogoModal; 